import {Button, Checkbox, Divider} from 'antd';
import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import {toast} from 'react-hot-toast';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';

import {RqGetActiveOffers} from '../../../reactQuery/apis';
import {addToCart} from '../../../redux/authAction';

import {ProductDetailInfo} from './ProductDetailInfo';

const ProductInformation = ({data}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [count, setCount] = useState(1);

  const [selectedSize, setSelectedSize] = useState(null);

  const [sizeError, setSizeError] = useState(false);

  const [isGift, setIsGift] = useState(false);

  const cart = useSelector(state => state.cart);
  
  const {data: offers} = RqGetActiveOffers();
  const offer = offers?.[0]?.applicableProductIds?.includes(data.id)
    ? offers[0]
    : null;

  useEffect(() => {
    if (data?.size?.length > 0) {
      const firstAvailableSize =
      data.size.find(item => Number(item.quantity) > 0) || data.size[0];

      setSelectedSize(firstAvailableSize?.size?.trim?.() || '');
      setCount(Number(firstAvailableSize?.quantity) > 0 ? 1 : 0);
    }
  }, [data]);

  const selectedSizeData = data?.size?.find(
    item => item?.size?.trim?.() === selectedSize?.trim?.(),
  );

  const price = Number(selectedSizeData?.price || 0);
  const discountedPrice = offer
    ? Math.round(price - (price * offer.maxDiscount) / 100)
    : price;

  const hasDiscount = discountedPrice < price;

  const handleSizeSelect = size => {
    setSelectedSize(size?.trim?.() || '');

    const selectedSizeData = data.size.find(
      item => item?.size === size,
    );

    if (Number(selectedSizeData?.quantity) <= 0) {
      setCount(0);
    } else {
      setCount(1);
    }
  };

  const increase = () => {
    if (!selectedSize) {
      setSizeError(true);
      return;
    }
    const selectedSizeData = data.size.find(item => item.size === selectedSize);
    if (selectedSizeData.quantity > count) {
      setCount(prev => prev + 1);
    }
    if (count >= selectedSizeData.quantity) {
      toast.error(`Only ${selectedSizeData.quantity} products of size ${selectedSize} are available in stock.`);
    } 
  };

  const decrease = () => {
    setCount(prev => (prev > 1 ? prev - 1 : 1));
  };

  const handleClickButton = type =>{
    if (!selectedSize || selectedSize === '') {
      setSizeError(true);
      return;
    }
    const selectedSizeData = data.size.find(item => item.size === selectedSize);
    const existingCartItem = cart.items.find(item => item.productId === data.id && item.size === selectedSize);
    if (type === 'fromCart') {
      if (existingCartItem) {
        if (existingCartItem.quantity + count > selectedSizeData.quantity) {
          toast.error(`Only ${selectedSizeData.quantity} products of size ${selectedSize} are available in stock.`);
          return;
        }
      } else {
        if (count > selectedSizeData.quantity) {
          toast.error(`Only ${selectedSizeData.quantity} products of size ${selectedSize} are available in stock.`);
          return;
        }
      }
    }
    const finalPrice = hasDiscount ? discountedPrice : price;

    const productData = {
      productId: data.id,
      productName: data.productName,
      productType: data.productType,
      jewelryType: data.jewelryType,
      size: selectedSize,
      quantity: count,
      pricePerUnit: parseFloat(finalPrice),
      imageUrl: data.imageUrl,
      description: data.description,
      sizeQuantity: data.size.find(item => item.size === selectedSize).quantity,
      weight: {
        grossWeight: data.weight?.grossWeight || '',
        netWeight: data.weight?.netWeight || '',
      },
      totalAmount: (hasDiscount ? discountedPrice : price) * count,
      gift: isGift,
    };

    if(type === 'fromBuy'){
      navigate('/checkout', {state: {product: productData}});
    }else{
      dispatch(addToCart(productData));
      navigate('/cart');
    }
  };

  const selectedSizeInfo = data?.size?.find(
    item => item?.size?.trim?.() === selectedSize?.trim?.(),
  );
  return (
    <div className={'flex flex-col lg:flex-row lg:gap-4 gap-2 lg:py-4 lg:px-7 p-3 shadow-md rounded-lg w-full'}>
      <div className={'flex flex-col gap-2 w-full'}>
        <h1 className={'lg:text-2xl text-lg font-semibold text-primary-800 font-serif-custom capitalize'}>
          {data?.productName}
        </h1>

        <p className={'font-semibold text-primary-800 text-xl flex flex-col gap-2'}>
          <p>
            <span className={'text-primary-900 mr-2 text-2xl'}>
           &#8377; {discountedPrice || price}   
            </span>
            {hasDiscount && (
              <span className={'text-[#D10000] text-lg font-semibold'}>
              ({offer.maxDiscount}% OFF)
              </span>
            )}
          </p>
          {hasDiscount && (
            <span className={'line-through text-gray'}>
            MRP {price}
            </span>
          )}   
        </p>
        <div className={'flex gap-2'}>
          <p className={'text-base font-semibold'}>Availability :</p>

          {selectedSizeInfo ? (
            selectedSizeInfo.quantity > 0 ? (
              selectedSizeInfo.quantity < 5 ? (
                <span className={'text-[#FF0000]'}>
          Only {selectedSizeInfo.quantity} remaining !
                </span>
              ) : (
                <span className={'text-primary-900'}>In Stock</span>
              )
            ) : (
              <span className={'text-[#FF0000]'}>Out of Stock</span>
            )
          ) : (
            <span className={'text-[#FF0000]'}>Select size</span>
          )}

        </div>

        <div className={'flex gap-2 items-center'}>
          <h1 className={'font-semibold text-base'}>Gift Option:</h1>
          <Checkbox className={'flex items-center h-10'}
            checked={isGift}
            onChange={e => setIsGift(e.target.checked)}
          >
              This is a gift
          </Checkbox>
        </div>

        <div className={'font-semibold'}>Select Size:</div>
        <div className={'flex flex-col'}>
          <div className={'h-8 flex flex-row gap-2'}>
            {data.size?.map(item => (
              <Button
                key={item.size}
                onClick={() => handleSizeSelect(item.size)}
                disabled={item.quantity <= 0}
                className={`border-2 ${
                  selectedSize === item.size
                    ? '!border-primary-900 !bg-primary-900 !text-white'
                    : item.quantity > 0
                      ? '!border-primary-800 !text-black'
                      : '!border-gray-400 !text-gray-400'
                }`}
              >
                {item.size}
              </Button>
            ))}
          </div>
          {sizeError && (
            <p className={'text-[#FF0000] text-sm'}>Please select a size !</p>
          )}
        </div>

        <div className={'flex flex-row items-center gap-2 my-2'}>
          <div className={'font-semibold'}>Quantity :</div>
          <Button
            onClick={decrease}
            disabled={count === 1}
            className={'w-3 h-6 rounded-lg !bg-primary-100 border-none hover:!border-gray-400 hover:!bg-gray-300'}
          >
            <h1 className={'text-black'}>-</h1>
          </Button>
          <h1 className={'text-base font-bold'}>{count}</h1>
          <Button
            onClick={increase}
            className={
              'w-3 h-6 rounded-lg !bg-primary-100 border-none hover:!border-gray-400 hover:!bg-gray-300'
            }
          >
            <h1 className={'text-black'}>+</h1>
          </Button>
        </div>

        <div className={'flex gap-2 mt-2'}>
          {data.jewelryType === 'GOLD' ? (
            <Link to={'/contact'}>
              <Button
                className={'group lg:w-40 w-32 h-8 rounded-lg border-primary-900 text-primary-900 text-md font-semibold hover:shadow-[0_0_5px_#3D180F] active:scale-95'}
              >
                Contact Us
              </Button>
            </Link>
          ) : (
            <>
              <Button
                onClick={()=>handleClickButton('fromBuy')}
                className={'group lg:w-40 w-32 h-8 rounded-lg border-primary-900 text-primary-900 text-md font-semibold hover:shadow-[0_0_5px_#3D180F] active:scale-95'}>
                  Buy Now
              </Button>
              <Button
                onClick={()=>handleClickButton('fromCart')}
                className={'group lg:w-40 w-32 h-8 rounded-lg border-primary-900 text-primary-900 text-md font-semibold hover:shadow-[0_0_5px_#3D180F] active:scale-95'}
              >
                  Add To Cart
              </Button>
            </>
          )}
        </div>
        <Divider className={'my-1.5'} />
        <ProductDetailInfo data={data} />
      </div>
    </div>
  );
};

ProductInformation.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    productName: PropTypes.string,
    productType: PropTypes.string,
    jewelryType: PropTypes.string,
    imageUrl: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
    weight: PropTypes.shape({
      grossWeight: PropTypes.string,
      netWeight: PropTypes.string,
    }),
    size: PropTypes.arrayOf(
      PropTypes.shape({
        size: PropTypes.string,
        quantity: PropTypes.string,
      }),
    ),
    description: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default ProductInformation;
